export default [
  {
    name: 'getOperatorLog',
    method: 'GET',
    path: '/vue/system/operatorlog-get'
  },
  {
    name: 'getOperatorLogPage',
    method: 'POST',
    path: '/vue/system/operatorlog-page'
  },
  {
    name: 'saveOperatorLog',
    method: 'POST',
    path: '/vue/system/operatorlog-save'
  },
  {
    name: 'deleteOperatorLog',
    method: 'POST',
    path: '/vue/system/operatorlog-delete'
  },
  {
    name: 'deleteByDate',
    method: 'POST',
    path: '/vue/system/operatorlog-delete-by-date'
  }
];
